export class GraphUser {
    // noinspection JSUnusedGlobalSymbols
    city: string;
    // noinspection JSUnusedGlobalSymbols
    companyName: string;
    // noinspection JSUnusedGlobalSymbols
    country: string;
    // noinspection JSUnusedGlobalSymbols
    state: string;
    // noinspection JSUnusedGlobalSymbols
    streetAddress: string;
    // noinspection JSUnusedGlobalSymbols
    displayName: string;
    // noinspection JSUnusedGlobalSymbols
    givenName: string;
    // noinspection JSUnusedGlobalSymbols
    id: string;
    // noinspection JSUnusedGlobalSymbols
    jobTitle: string;
    // noinspection JSUnusedGlobalSymbols
    mail: string;
    // noinspection JSUnusedGlobalSymbols
    officeLocation: string;
    // noinspection JSUnusedGlobalSymbols
    preferredLanguage: string;
    // noinspection JSUnusedGlobalSymbols
    surname: string;
    // noinspection JSUnusedGlobalSymbols
    userPrincipalName: string;
    // noinspection JSUnusedGlobalSymbols
    postalCode: string;
    // noinspection JSUnusedGlobalSymbols
    onPremisesSamAccountName: string;
}
